<div class="row">
  <!-- Colonna articoli: si allarga se idMansione = 0 -->
  <div
    [class]="{
      'col-12': true,
      'col-md-9': idMansione > 0,
      'col-md-12': idMansione === 0,
    }"
  >
    <!-- grid gestione degli articoli previsti -->
    <app-articoli-previsti-by-dipendente
      [idDipendente]="idDipendente"
      [idMansione]="idMansione"
      [bConsultazione]="bConsultazione"
      [tipoFiltro]="tipoFiltro"
      [listDettaglioBS]="listDettaglioBS"
      (listEventEmitter)="caricaLista($event)"
    ></app-articoli-previsti-by-dipendente>
  </div>

  <!-- Colonna tipologie mansione: visibile solo se idMansione > 0 -->
  @if (idMansione > 0) {
    <div class="col-12 col-md-3">
      <app-tipi-articoli-assegnati-by-mansione
        [idMansione]="idMansione"
        [listDetArtDip]="listDetArtDip"
      ></app-tipi-articoli-assegnati-by-mansione>
    </div>
  }
</div>
